import { TextInput as _TextInput } from 'components/Inputs';
import { H6 } from 'components/Typography';
import { sizes } from 'style';
import styled from 'styled-components';
import { NavigationButtons as _NavigationButtons } from '../../styled';

export const ClaimHeading = styled(H6)`
  @media ${sizes.desktop} {
    margin-bottom: 12px;
    font-size: 20px;
  }
`;

export const FieldLabel = styled.b`
  display: block;
  margin-bottom: 8px;
`;

export const TextInput = styled(_TextInput)`
  max-width: 320px;
`;

export const NavigationButtons = styled(_NavigationButtons)`
  margin-top: 48px;
`;
